import { render } from "./MisCategorias.vue?vue&type=template&id=77886945&scoped=true"
import script from "./MisCategorias.vue?vue&type=script&lang=js"
export * from "./MisCategorias.vue?vue&type=script&lang=js"

import "./MisCategorias.vue?vue&type=style&index=0&id=77886945&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77886945"]])

export default __exports__